import Image from "next/image";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import classNames from "classnames";
import blurMap from "@/public/images/blurMap.png";
import blured from "@/public/images/blured.png";
import { Loader } from "@/components/common/loader/Loader";
import styles from "./StaticMap.module.scss";

type StaticMapProps = {
  mapName: string;
  forceX?: number;
  forceY?: number;
  forceZoom?: string;
  folder?: string;
};

export const StaticMap = ({
  mapName,
  forceX,
  forceY,
  forceZoom,
  folder,
}: StaticMapProps) => {
  const intl = useIntl();

  const zoom = forceZoom !== undefined ? forceZoom : "13";
  const [isUmapSrcLoaded, setIsUmapSrcLoaded] = useState<boolean>(false);
  const [isUmapDisplayed, setIsUmapDisplayed] = useState<boolean>(
    folder === undefined
  );
  const [isLoaderDisplayed, setIsLoaderDisplayed] = useState<boolean>(false);
  const [isBlurMapDisplayed, setIsBlurMapDisplayed] = useState<boolean>(
    folder !== undefined
  );
  const umapBaseSrc = `//umap.openstreetmap.fr/fr/map/${mapName}?scaleControl=false&miniMap=false&scrollWheelZoom=false&zoomControl=true&allowEdit=false&moreControl=false&searchControl=true&tilelayersControl=null&embedControl=null&datalayersControl=null&onLoadPanel=undefined&captionBar=false#${zoom}/`;
  const [umapSrc, setUmapSrc] = useState<string>();

  const staticMapBaseSrc = `https://cube-map-images.s3.eu-west-3.amazonaws.com`;
  const [staticMapSrc, setStaticMapSrc] = useState<string>();
  const [staticImageErr, setStaticImageErr] = useState<boolean>(false);

  const getUserGeolocation = () => {
    if (forceX !== undefined && forceY !== undefined) {
      console.log(`${umapBaseSrc}${forceX}/${forceY}`);
      setUmapSrc(`${umapBaseSrc}${forceX}/${forceY}`);
      if (folder !== undefined) {
        setStaticMapSrc(
          `${staticMapBaseSrc}/${folder}/${forceX},${forceY}.jpg`
        );
      }
      setIsUmapSrcLoaded(true);
    } else {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          console.log("ICI");
          console.log(
            `${umapBaseSrc}${pos.coords.latitude.toString()}/${pos.coords.longitude.toString()}`
          );
          setUmapSrc(
            `${umapBaseSrc}${pos.coords.latitude.toString()}/${pos.coords.longitude.toString()}`
          );
          setIsUmapSrcLoaded(true);
        },
        () => {
          console.log("LA");
          setUmapSrc(`${umapBaseSrc}48.85/2.34`);
          setIsUmapSrcLoaded(true);
        }
      );
    }
  };

  const showUmap = () => {
    setIsLoaderDisplayed(true);
    setIsUmapDisplayed(true);
    setTimeout(() => {
      setIsBlurMapDisplayed(false);
    }, 700);
  };

  useEffect(() => {
    getUserGeolocation();
  });

  return (
    <div className={styles.container}>
      <div className={styles.imageWrapper} onClick={() => showUmap()}>
        {isBlurMapDisplayed && (
          <Image
            className={styles.screenshot}
            layout="fill"
            src={staticImageErr ? blured : staticMapSrc ?? ""}
            placeholder={"blur"}
            blurDataURL={blurMap.src}
            alt="static-map"
            sizes="(max-width: 959px) 100vw, (max-width: 1279px) 75vw, 50vw"
            onError={() => setStaticImageErr(true)}
          />
        )}
        <p
          className={classNames(styles.screenshotText, {
            [styles.shown]: !isLoaderDisplayed && isBlurMapDisplayed,
          })}
        >
          {intl.formatMessage({ id: "blurMapText" })}
        </p>

        {isLoaderDisplayed && <Loader />}
      </div>

      {isUmapDisplayed && (
        <div
          className={classNames(styles.umap, {
            [styles.shown]: !isBlurMapDisplayed && isUmapSrcLoaded,
          })}
        >
          <iframe width="100%" height="100%" src={umapSrc} />
        </div>
      )}
    </div>
  );
};
